import { ColumnDef } from '@tanstack/react-table'
import { CheckCircle2, XCircle } from 'lucide-react'
import { PageScroll } from 'app/components/layout/PageScroll'
import { PageHeader } from 'app/components/page-header/PageHeader'
import TableLayout from 'app/components/table/TableLayout'
import { OpenLinkCell } from 'app/components/table/OpenLinkCell'
import { LocationJson } from 'app/types/entities'

export type SettingsAvailabilityShadcnComponentProps = {
  locations: { hits: LocationJson[]; total: number }
  columns: ColumnDef<LocationJson, any>[]
}

export function SettingsAvailabilityShadcnComponent({ locations, columns }: SettingsAvailabilityShadcnComponentProps) {
  const enhancedColumns: ColumnDef<LocationJson, any>[] = columns.map((col) => {
    if (col.id === `Location Name`) {
      return {
        ...col,
        // A controlled cell fills the whole cell, so the hover Open button sits at its right edge.
        meta: {
          ...col.meta,
          ControlledComponent: (row) => (
            <OpenLinkCell href={`/settings/availability/${row?.id}`} label={row?.name ?? ``} />
          ),
        },
      }
    }
    if (col.id === `Scheduler` || col.id === `AI Agent`) {
      return {
        ...col,
        cell: (props) => (
          <span>
            {props.row.original.products?.includes(col.id as any) ? (
              <CheckCircle2 className="h-5 w-5 text-blue-400" />
            ) : (
              <XCircle className="h-5 w-5 text-red-400" />
            )}
          </span>
        ),
      }
    }
    return col
  })

  return (
    <PageScroll variant="table" header={<PageHeader title="Availability" totalItems={locations?.total} />}>
      <TableLayout data={locations} columns={enhancedColumns as any} edgePadded />
    </PageScroll>
  )
}
